module.exports = __webpack_public_path__ + "img/img8.9a629cea.png";